module.exports = __webpack_public_path__ + "img/UponWaking.6a355f4e.svg";